/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConsentEndPoints } from "./configEndPoints";
import { post, ApiResponse } from "../helpers";
import { FormFieldItemValues } from "../models/formRenderModel";
import { UserConsentPdfFiles } from "../models/fileUploadModel";

const getUserConsentPdfFiles = async (): Promise<
  ApiResponse<UserConsentPdfFiles[]>
> =>
  post<string, UserConsentPdfFiles[]>(
    ConsentEndPoints.GetUserConsentPdfFiles,
    ""
  );

const getConsentFormItems = async (): Promise<ApiResponse<FormFieldItemValues>> =>
  post<string, FormFieldItemValues>(
    ConsentEndPoints.GetConsentFormItems,
    ""
  );

const documentViewer = async (pkid: number): Promise<ApiResponse<any>> =>
  post<number, any>(ConsentEndPoints.DocumentViewer, pkid);

const downloadUserConsentPdfFile = async (
  id: number
): Promise<ApiResponse<any>> =>
  post<number, any>(ConsentEndPoints.DownloadUserConsentPdfFile, id);

const checkUserConsentPdfFileExist = async (): Promise<ApiResponse<boolean>> =>
  post<string, boolean>(ConsentEndPoints.CheckUserConsentPdfFileExist, "");

const checkUserMarketingConsent = async (): Promise<ApiResponse<boolean>> =>
  post<string, boolean>(ConsentEndPoints.CheckUserMarketingConsent, "");

// eslint-disable-next-line @typescript-eslint/naming-convention
const ConsentApi = {
  getUserConsentPdfFiles,
  getConsentFormItems,
  documentViewer,
  downloadUserConsentPdfFile,
  checkUserConsentPdfFileExist,
  checkUserMarketingConsent
};

export default ConsentApi;
